/**
 * Canned reason templates surfaced in the moderator Reject and
 * Request-changes dialogs. Moderators pick a starter and edit it before
 * sending so each reply still reads as a human voice rather than a form
 * letter. Phrasing follows the project's house style — no em dashes.
 */
export interface ReasonTemplate {
  key: string;
  label: string;
  body: string;
}

export const REJECT_REASON_TEMPLATES: ReasonTemplate[] = [
  {
    key: 'wrong-rights',
    label: 'Wrong rights',
    body:
      "Thanks for sharing this. After review, we are not able to publish material the contributor doesn't have the rights to share. If you are the original creator or have permission from them, please resubmit with a note.",
  },
  {
    key: 'out-of-scope',
    label: 'Out of scope',
    body:
      "Thanks for your contribution. This piece sits outside the archive's focus on Brisbane LGBTQ+ history. If you have material connected to that scope, you are very welcome to submit it.",
  },
  {
    key: 'test-submission',
    label: 'Test submission',
    body:
      'It looks like this submission may have been a test upload. If you intended to submit something else, please try again.',
  },
];

export const REQUEST_CHANGES_TEMPLATES: ReasonTemplate[] = [
  {
    key: 'more-context',
    label: 'Need more context',
    body:
      "We'd love to add this to the archive. Can you tell us a little more about: who, when, where, and the story behind it?",
  },
  {
    key: 'sensitive-unmarked',
    label: 'Sensitive content unmarked',
    body:
      'This material may need a content warning. Can you let us know if there is anything viewers should be prepared for?',
  },
];
